import axios from 'axios'

// 官网智能问答服务（独立于 CMS 后端 request.js）
// 接口文档：POST /api/public/search，请求头 X-Api-Key
const PUBLIC_SEARCH_BASE_URL = (process.env.VUE_APP_PUBLIC_SEARCH_BASE_URL || '').replace(/\/$/, '')
const PUBLIC_SEARCH_API_KEY = process.env.VUE_APP_PUBLIC_SEARCH_API_KEY || ''
// AI 生成回答较慢，超时时间可通过 .env 配置（毫秒），未配置时默认 30s
const PUBLIC_SEARCH_TIMEOUT = Number(process.env.VUE_APP_PUBLIC_SEARCH_TIMEOUT) || 30 * 1000

const publicSearchService = axios.create({
  baseURL: PUBLIC_SEARCH_BASE_URL,
  timeout: PUBLIC_SEARCH_TIMEOUT
})

// 请求拦截器：注入 X-Api-Key
publicSearchService.interceptors.request.use(config => {
  config.headers = {
    'Content-Type': 'application/json',
    'X-Api-Key': PUBLIC_SEARCH_API_KEY
  }
  return config
}, error => Promise.reject(error))

// AI 问答接口耗时较长，超时（前端 axios 超时，或服务端返回的超时错误）统一
// 按「网络问题」对外呈现，不把超时等服务端内部细节暴露给用户。
const TIMEOUT_PATTERN = /timeout|timed out|超时|ECONNABORTED|ETIMEDOUT/i
const NETWORK_ERROR_MESSAGE = '网络开小差啦！请重新发送。'

function normalizeSearchResult(payload) {
  if (!payload || typeof payload !== 'object') {
    return { code: 'NETWORK_ERROR', message: NETWORK_ERROR_MESSAGE }
  }
  const code = String(payload.code || '')
  const message = String(payload.message || '')
  if (TIMEOUT_PATTERN.test(code) || TIMEOUT_PATTERN.test(message)) {
    return { code: 'NETWORK_ERROR', message: NETWORK_ERROR_MESSAGE }
  }
  return payload
}

// 响应拦截器：统一返回响应体 { code, message, data, timestamp }
publicSearchService.interceptors.response.use(
  response => normalizeSearchResult(response.data),
  error => {
    const data = error && error.response ? error.response.data : null
    return Promise.resolve(normalizeSearchResult(data))
  }
)

/**
 * 官网智能问答搜索
 * @param {string} question 用户问题，最多 2000 字符
 * @returns {Promise<{code:string,message:string,data:{answerId:string,answer:string,references:Array<{title:string,url:string,source:string,types:string[],typeLinks:Array<{name:string,url:string}>}>},timestamp:string}>}
 */
export function publicSearch(question) {
  return publicSearchService.post('/api/public/search', { question })
}

/**
 * 官网搜索联想
 * @param {string} q 用户当前输入内容，最多 100 字符
 * @param {number} [limit=5] 返回数量，范围 1～8
 * @param {AbortSignal} [signal] 取消信号，用于中止未完成的联想请求
 * @returns {Promise<{code:string,message:string,data:{query:string,normalizedQuery:string,suggestions:Array<{question:string,keyword:string}>},timestamp:string}>}
 */
export function publicSearchSuggestions(q, limit = 5, signal) {
  return publicSearchService.get('/api/public/search/suggestions', {
    params: { q, limit },
    signal
  })
}

export default {
  publicSearch,
  publicSearchSuggestions
}
